module.exports = __webpack_public_path__ + "static/media/o_projektu.9472d7f5.png";